var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessages3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.415 6.25V11.35C22.415 12.62 21.995 13.69 21.245 14.43C20.505 15.18 19.435 15.6 18.165 15.6V17.41C18.165 18.09 17.405 18.5 16.845 18.12L15.875 17.48C15.965 17.17 16.005 16.83 16.005 16.47V12.4C16.005 10.36 14.645 9 12.605 9H5.81503C5.67503 9 5.54504 9.01002 5.41504 9.02002V6.25C5.41504 3.7 7.11504 2 9.66504 2H18.165C20.715 2 22.415 3.7 22.415 6.25Z",
    stroke: "#8F95B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.005 12.4V16.47C16.005 16.83 15.965 17.17 15.875 17.48C15.505 18.95 14.285 19.87 12.605 19.87H9.88504L6.86504 21.88C6.41504 22.19 5.81503 21.86 5.81503 21.32V19.87C4.79503 19.87 3.94504 19.53 3.35504 18.94C2.75504 18.34 2.41504 17.49 2.41504 16.47V12.4C2.41504 10.5 3.59504 9.19002 5.41504 9.02002C5.54504 9.01002 5.67503 9 5.81503 9H12.605C14.645 9 16.005 10.36 16.005 12.4Z",
    stroke: "#8F95B7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages3);
export default __webpack_public_path__ + "static/media/messages-3.9c24b3b3bf90b9d9e906acb71f99679f.svg";
export { ForwardRef as ReactComponent };